module.exports = __webpack_public_path__ + "img/ct_bru-composition1.d43d7461.png";